export class EmployeeAccountStatus {
    id = null;

    description = '';
}
